/**
 * Created by jacmai on 3/3/2017.
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/shared/adminMenu/adminMenuView",
  "modules/shared/adminMenu/adminMenuModel",
], function (Marionette, Messenger, AdminMenuView) {
  var KbAdminMenuController = Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "adminmenu";
    },
    show: function (menuType, menuItems, namespace, selectedItem) {
      this.view = new AdminMenuView.menuView({ model: menuType, collection: menuItems });
      this.view.on(
        "itemview:click:menu",
        function (menuItemView) {
          //ignore clicks on disabled models
          if (menuItemView.model.get("disabled")) return;
          Messenger.save(function (success) {
            if (success) {
              var activeItem = menuItems.activeItem;
              if (activeItem) {
                var activeItemView = this.view.children.findByModel(activeItem);
                activeItemView.deselect();
                if (activeItemView != menuItemView) {
                  activeItemView.close();
                }
              }
              menuItems.activeItem = menuItemView.model;
              menuItemView.setTabActive();
              Messenger.vent.trigger("show:" + namespace + ":" + menuItemView.model.get("name"));
            }
          }, this);
        },
        this,
      );
      this.view.on(
        "itemview:click:submenu",
        function (menuItemParentView, menuItemModel) {
          //ignore clicks on disabled models
          if (menuItemModel.model.get("disabled")) return;
          Messenger.save(function (success) {
            if (success) {
              this.view.children.findByModel(menuItems.activeItem).deselect();
              menuItemModel.setTabActive();
              Messenger.vent.trigger("show:" + namespace + ":" + menuItemModel.model.get("name"));
            }
          }, this);
        },
        this,
      );
      //trigger the display of the default menu item
      var defaultMenuModel = menuItems.findWhere({ default: true });
      menuItems.activeItem = defaultMenuModel;
      var selectedMenuModel;
      if (selectedItem) {
        selectedMenuModel = menuItems.findWhere({ name: selectedItem });
        if (selectedMenuModel) {
          selectedMenuModel.set("default", true);
          menuItems.activeItem = selectedMenuModel;
          if (defaultMenuModel) {
            defaultMenuModel.set("default", false);
          }
        }
      }
      if (!selectedMenuModel) {
        if (menuItems.activeItem) {
          Messenger.vent.trigger("show:" + namespace + ":" + menuItems.activeItem.get("name"));
        } else {
          Messenger.vent.trigger("show:" + namespace);
        }
      }
      this.showRegion(this.view);
    },
  });

  return KbAdminMenuController;
});
